module.exports = __webpack_public_path__ + "assets/img/GAMMA.053c3a58.png";